import { EMPTY_LIST } from '../../../../constants/common'
import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import { PhaseItemStatus } from '../../../Entity'
import { APPLICANT_STAGES } from '../../../RentalPortalApplicant'
import { formatDate } from '../../../Table'
import { getRentalPortalApplicantPortalLabel } from '../../RentalPortalApplicantPortalCell'

import {
  APPLICANT_PHASE_STATE,
  APPLICANT_PHASE_TERMINAL_STATEMENT_KEY,
} from './RentalPortalApplicantProfileHeaderInfoItems.constants'

function getApplicantPhaseItemStatus(state) {
  switch (state) {
    case APPLICANT_PHASE_STATE.done:
      return PhaseItemStatus.finished
    case APPLICANT_PHASE_STATE.active:
      return PhaseItemStatus.inProgress
    default:
      return PhaseItemStatus.notStarted
  }
}

export function getApplicantShortDate({ date, locale, timezone }) {
  return formatDate({
    date,
    dateFormat: DATE_SHORT_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })
}

export function getApplicantPhaseItems({ isTerminal, phases, t }) {
  return (phases || EMPTY_LIST).map(({ key, state }) => ({
    id: key,
    name: APPLICANT_STAGES[key] ? t(APPLICANT_STAGES[key].text) : null,
    status: isTerminal
      ? PhaseItemStatus.notStarted
      : getApplicantPhaseItemStatus(state),
  }))
}

export function getApplicantPhaseTerminalStatement({
  locale,
  phase,
  t,
  terminalDate,
  timezone,
}) {
  const statementKey =
    APPLICANT_PHASE_TERMINAL_STATEMENT_KEY[phase?.terminal_reason]

  return statementKey && terminalDate
    ? t(statementKey, {
        date: getApplicantShortDate({ date: terminalDate, locale, timezone }),
      })
    : t('RentalPortal.ListingPhaseTerminalNoActionKey')
}

export function getApplicantPortalReceivedValue({
  applicantData,
  locale,
  t,
  timezone,
}) {
  return [
    getRentalPortalApplicantPortalLabel({ applicant: applicantData, t }),
    getApplicantShortDate({
      date: applicantData?.received_at,
      locale,
      timezone,
    }),
  ]
    .filter(Boolean)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}
